import { isEqual } from 'lodash';
import { useEffect, useRef } from 'react';

export const KONAMI_CODE = [
  'ArrowUp',
  'ArrowUp',
  'ArrowDown',
  'ArrowDown',
  'ArrowLeft',
  'ArrowRight',
  'ArrowLeft',
  'ArrowRight',
  'Enter',
] as const;

export default function useKonamiCode(onUnlock: () => void, sequence: readonly string[] = KONAMI_CODE) {
  const onUnlockRef = useRef(onUnlock);
  onUnlockRef.current = onUnlock;
  const sequenceRef = useRef(sequence);
  sequenceRef.current = sequence;

  useEffect(() => {
    const buffer: string[] = [];

    const handleKeyDown = (e: KeyboardEvent) => {
      const sequence = sequenceRef.current;
      buffer.push(e.key);
      if (buffer.length > sequence.length) {
        buffer.shift();
      }
      if (isEqual(buffer, sequence)) {
        buffer.length = 0;
        onUnlockRef.current();
      }
    };

    window.addEventListener('keydown', handleKeyDown);
    return () => window.removeEventListener('keydown', handleKeyDown);
  }, []);
}
